export const CONTRACTS = "/api/partnerships/templates"
export const CONTRACT = "/api/partnerships/templates/:param"
export const EXPORT_CONTRACT_EXAMPLE = "/api/templates-example"